exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#slots .fixed-answer.fixed-answer_blue,#slots div[id].element.element_section3b2{border:2px solid #fff;background:#a7dec3;overflow:auto;min-height:84px}.unit3b-2 .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:6px 10px 2px;color:#fff;cursor:pointer;outline:none;text-decoration:none;transition:opacity .5s,display .1s .5s;opacity:1}.unit3b-2 #slots .hint{position:absolute;top:55px;right:-10px;transition:all .4s;opacity:1;z-index:3}.unit3b-2 .unit-diagram{padding-top:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/3/3b2/diagram1/diagram1.scss
// module id = 1202
// module chunks = 0